import React, { useEffect } from 'react'
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom'
import Overview from 'pages/Overview'
import DashboardV2 from 'pages/DashboardV2'
import Registration from 'pages/Registration'
import ProtectedRoute from './Protected'
import Offline from 'includes/Offline'
import Promo from 'pages/Promo'
import Settings from 'pages/Settings'
import Transaction from 'pages/Transaction'
import Billing from 'pages/Billing'
import Payout from 'pages/Payout'
import Settlements from 'pages/Settlements'
import Pos from 'pages/POS'
import PromoCardDetails from 'pages/Promo/components/PromoCardDetails'
import CampaignDetail from 'pages/Promo/components/CampaignDetail'
import RedemptionVault from 'pages/RedemptionVault'
import Credits from 'pages/Credits'
import Deposits from 'pages/Deposits'
import CashFlow from 'pages/CashFlow'
import MovieBox from 'pages/MovieBox'
import TrailerDetails from 'pages/MovieBox/components/TrailerDetails'
import EditTTrailer from 'pages/MovieBox/components/EditTTrailer'
import Review from 'pages/Review'
import Reports from 'pages/Reports'
import RewardAds from 'pages/RewardAds'
import RewardAdDetail from 'pages/RewardAds/components/Detail'
import CreateRewardAd from 'pages/RewardAds/components/Create'
import { Navigate } from 'react-router-dom/dist'
import Customer from 'pages/Customers'
import axios from 'axios'
import { MovieDetails } from 'pages/MovieBox/MovieDetails'
import AddMovie from 'pages/MovieBox/AddMovie/AddMoviePage'
import Season from 'pages/MovieBox/AddMovie/screens/Season'

export default function Pages() {

  const navigate = useNavigate()
  const location = useLocation()


  useEffect(() => {
    async function onlineStatus() {
      try {
        await axios.get('https://jsonplaceholder.typicode.com/todos/1')
        if (location.pathname === '/offline') {
          navigate(-1)
        }
      }
      catch ({ message }) {
        console.log(message)
        navigate('/offline')
      }
    }

    // onlineStatus()
  }, [navigate, location.pathname])
  const Redirect = ({ to }) => { return <Navigate to={to} replace={true} /> }

  return (
    // <BrowserRouter>
    <Routes>
      <Route exact path="/" element={<Redirect to={'/dashboard'} />} />
      <Route exact path="/login" element={<Registration />} />
      <Route exact path="/register" element={<Registration />} />
      <Route exact path="/forgot-password" element={<Registration />} />
      <Route exact path="/offline" element={<Offline />} />
      <Route exact path="/dashboard" element={<ProtectedRoute component={DashboardV2} />} />
      <Route exact path="/dashboard_v1" element={<ProtectedRoute component={Overview} />} />
      <Route exact path="/overview" element={<Redirect to={'/dashboard'} />} />
      <Route exact path="/settings" element={<Redirect to='/settings/hub' />} />
      <Route exact path="/settings/:name" element={<ProtectedRoute component={Settings} />} />
      <Route exact path="/redemption-vault" element={<ProtectedRoute component={RedemptionVault} />} />
      <Route exact path="/promo" element={<ProtectedRoute component={Promo} />} />
      <Route exact path="/promo/campaigns/:id" element={<ProtectedRoute component={CampaignDetail} />} />
      <Route exact path="/promo/:name" element={<ProtectedRoute component={PromoCardDetails} />} />
      <Route exact path="/promo/:name/:action" element={<ProtectedRoute component={PromoCardDetails} />} />
      <Route exact path="/transactions" element={<ProtectedRoute component={Transaction} />} />
      <Route exact path="/billing" element={<ProtectedRoute component={Billing} />} />
      <Route exact path="/payout" element={<ProtectedRoute component={Payout} />} />
      <Route exact path="/customers" element={<ProtectedRoute component={Customer} />} />
      <Route exact path="/customers/:type" element={<ProtectedRoute component={Customer} />} />
      <Route exact path="/pos" element={<ProtectedRoute component={Pos} />} />
      <Route exact path="/credits" element={<ProtectedRoute component={Credits} />} />
      <Route exact path="/deposits" element={<ProtectedRoute component={Deposits} />} />
      <Route exact path="/cash-flow" element={<ProtectedRoute component={CashFlow} />} />
      <Route exact path="/movie-box" element={<ProtectedRoute component={MovieBox} />} />
      <Route exact path="/movie-box/:movieId" element={<ProtectedRoute component={MovieDetails} />} />
      <Route exact path="/movie-box/add-season" element={<ProtectedRoute component={MovieDetails} />} />
      <Route exact path="/reviews" element={<ProtectedRoute component={Review} />} />
      <Route exact path="/reports" element={<ProtectedRoute component={Reports} />} />
      <Route exact path="/reward-ads" element={<ProtectedRoute component={RewardAds} />} />
      <Route exact path="/reward-ads/create" element={<ProtectedRoute layout={false} component={CreateRewardAd} />} />
      <Route exact path="/reward-ads/:id" element={<ProtectedRoute component={RewardAdDetail} />} />
      <Route exact path="/settlements" element={<ProtectedRoute component={Settlements} />} />
      <Route exact path="/movie-box/add-movie/" element={<AddMovie />} />
      <Route exact path="/movie-box/add-movie/:step" element={<AddMovie />} />
      <Route exact path="/movie-box/:movieId/season/:seasonId" element={<Season />} />
      <Route exact path="/movie-box/:movieId/trailers/:trailerId" element={<ProtectedRoute layout={false} component={TrailerDetails} />} />
      <Route exact path="/movie-box/:movieId/trailers/:trailerId/edit" element={<ProtectedRoute layout={false} component={EditTTrailer} />} />
      {/* <Redirect to="/login" /> */}
    </Routes>
    // </BrowserRouter>
  )
}
